import { ApiResponse, TokenData, Sector } from '../models';
import * as http from './http';
import ApiService from './service';

export class SectorService extends ApiService {
  public async loadAllSector() {
    const url = `${this.apiDomain}/api/sector`;

    const resposne = await http.get<ApiResponse<Sector[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateSector(data: Sector, id?: string) {
    const url = `${this.apiDomain}/api/sector/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createSector(data: Sector) {
    const url = `${this.apiDomain}/api/sector`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteSector(id?: string) {
    const url = `${this.apiDomain}/api/sector/${id}`;

    const response = await http.remove<ApiResponse<Sector>>(url, this.store);
    return response.data;
  }
}
